var lineLayer = function(map, lineData) {
  console.log("init");
  this.options = {
    unit: "m",
    globalCompositeOperation: "lighter",
    draw: "intensity"
  };
  this._map = map;
  this._lineData = lineData;
};

lineLayer.prototype.draw = function() {
  console.log("draw");
  console.log(this._lineData);
  console.log(this.options);
  let data = [];
  for (let i of this._lineData.slice(0, 500)) {
    data.push({
      geometry: {
        type: "LineString",
        coordinates: i.points[0]
      },
      lineWidth: Math.round(i.width_m),
      count: 30,
      fillStyle: i.pm10_color,
      strokeStyle: i.pm10_color
    });
  }
  console.log(data);
  var dataSet = new mapv.DataSet(data);
  var mapvLayer = new mapv.baiduMapLayer(this._map, dataSet, this.options);
};

lineLayer.prototype.clear = function() {
  console.log("clear");
  console.log(this.options);
};

export { lineLayer };
